/**
* Created by vouill on 3/30/18.
*/

<template>
  <div
    class="v-container">
    <div class="img-container">
      <div class="tag-container"><span
        v-if="article.youtubeVideoId"
        class="tag is-danger">
        <span class="icon is-small">
          <i class="fas fa-play"/>
        </span> Video
      </span>
      </div>
      <img
        class="picture"
        :src="imgMeta && `${imgMeta.file.url}?q=40`">
    </div>

    <div class="article">
      <router-link
        class="v-title"
        :to="`/article/${article && article.slug}`"> {{ article.title }}</router-link>
      <div class="preview"> <v-showdown :source="article.preview"/></div>
      <div class="authors">
        <Author
          v-for="(author, index) in article.authors"
          :author="author"
          :key="index"
          :data="data"
        />
        <div class="date">{{ article.publishedDate }}</div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.tag-container {
  position: absolute;
  top: 4px;
  right: 10px;
  .icon {
    margin-right: 4px !important;
    font-size: 10px;
  }
}
.v-container {
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  display: flex;
  box-shadow: 0 2px 10px 0 rgba(194, 194, 194, 0.5);
  transition: 0.2s ease-in;
  text-decoration: none;
  @media screen and (max-width: 900px) {
    flex-direction: column;
    img {
      height: 150px;
    }
  }
  &:hover {
    box-shadow: 0 4px 10px 0 rgba(194, 194, 194, 0.9);
  }
}

.img-container {
  position: relative;
  width: 100%;
}

.picture {
  max-height: 400px;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.article {
  flex-grow: 1;
  padding: 2em;
}
.preview {
  padding: 1em 0;
  /*color: #30383B;*/
}
.v-title {
  font-family: "Roboto Slab";
  color: #ef6c00;
  font-size: 22px;
  font-weight: bold;
  &:hover {
    color: darken(#ef6c00, 10%);
  }
}

.authors {
  display: flex;
  align-items: center;
  align-content: center;
}
.date {
  font-size: 14px;
}
</style>

<script>
import { getAsset } from "../../../utils/contentful";
import Author from "./Author";

export default {
  name: "MainArticle",
  components: { Author },
  props: { data: Object },
  computed: {
    article() {
      const { data } = this;
      return (data && data.items[0].fields) || {};
    },
    imgMeta: function() {
      const { data } = this;
      return (
        data &&
        getAsset(data.includes, data.items[0].fields.coverImg.sys.id).fields
      );
    }
  }
};
</script>
